import api from "../../../utilidades/interceptor";
import Swal from "sweetalert2";


const urlApi = process.env.REACT_APP_API_KEY;

export const getServicesByClient = (week, setServices, setLoading) => {
    api.get(`${urlApi}/operaciones/servicesByClient?week=${week}`)
        .then((res) => {
            setServices(res.data);
            setLoading(false);
        })
        .catch((error) => {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: "Ocurrio un error",
                text: error,
            });
        });
}
